<template>
  <div>
    <Header />
    <section class="login-page section-b-space mt90">
      <div class="container">
        <form class="theme-form" v-on:submit="checkForm" method="post">
          <div v-if="errors.length">
            <ul class="validation-error mb-3">
              <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
            </ul>
          </div>
          <div v-if="globalError">
            <ul class="validation-error mb-3">
              <li>{{ globalError }}</li>
            </ul>
          </div>
          <div class="w-90">
            <h2 class="text-center register-title">{{'Set New Password'}}</h2>
            <h4>{{resetUsername}}</h4>
            <div class="form-group">
              <label for="verificationcode" class="border-label"><i class="fa fa-user"></i></label>
              <input
                  type="text"
                  class="bottom-input"
                  id="verificationcode"
                  v-model="verificationcode"
                  placeholder="Enter the 6 digit verify code"
                  name="verificationcode"
                  required
              />
            </div>
            <div class="form-group">
              <label for="new_password" class="border-label"><i class="fa fa-key"></i></label>
              <input
                  type="new_password"
                  class="bottom-input"
                  id="new_password"
                  v-model="new_password"
                  placeholder="Enter your NEW password"
                  required
              />
            </div>
            <div class="form-group d-flex justify-content-center mt-5">
              <input type="submit" class="btn btn-register" value="Set new Password" />
            </div>
          </div>
        </form>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>

import Header from "../components/header";
import Footer from "../components/footer";

import { forgotPasswordSubmit } from "@/utils/auth.js";

import { mapGetters } from "vuex";
export default {
  components: {
    Header,
    Footer
  },
  computed: {
    ...mapGetters({
      globalError: "getGlobalError",
      resetUsername: 'auth/getResetUsername',
    })
  },
  data() {
    return {
      errors: [],
      verificationcode: null,
      new_password: null
    };
  },
  props: {
  },
  mounted() {
    this.$store.dispatch("setGlobalError",{value: ""});
  },
  methods: {


    checkForm: async function(e) {
      this.errors = [];
      if (!this.verificationcode) {
        this.errors.push("verification code is required.");
      }
      if (!this.new_password) {
        this.errors.push("New Password is required.");
      }
      e.preventDefault();
      if (!this.errors.length) {
        forgotPasswordSubmit(this.resetUsername,this.verificationcode,this.new_password,this.$store);
      }


    }
  }
};
</script>
